<template>
  <div>
    <Header />
    <div class="content-web container mt-5">
      <div class="row browse-top mb-5">
        <div class="col-12">
          <div class="form-group input-group input-group-lg col-md-12 p-0">
            <input
              class="input form-control mt-0"
              placeholder="Nội dung cần tìm kiếm"
              v-model="searchText"
              v-on:keyup.enter="getListIPs(true)"
            />
            <span class="input-group-append">
              <button
                type="button"
                id="btn-search"
                v-on:click="getListIPs(true)"
                class="btn-lg btn btn-search"
              >
                <i class="fa fa-search"></i>
              </button>
            </span>
          </div>
          <div class="row d-flex flex-column-reverse flex-md-row flex-lg-row">
            <div class="col-sm-12 col-md-8 col-lg-8">
              <!-- loading icon -->
              <div class="row d-flex justify-content-center mt-5" v-if="loading">
                <div class="text-center">
                  <div class="spinner-border text-dark" role="status">
                    <span class="sr-only">Đang tải...</span>
                  </div>
                </div>
              </div>

              <div class="row" v-else>
                <div class="col-12" >
                  <div v-if="dataSearch && dataSearch.length > 0" style="width:100%">
                    <list-search :data="dataSearch" :columnNumber="column"></list-search>
                    <div class="row col-12 mt-3 list-grid" v-if="totalData > perPage">
                      <div class="col-6">
                        <span
                          style="color: #3199bb;font-size:12;font-weight:700; "
                          v-if="((perPage*page) > totalData)"
                        >{{perPage*(page-1)+1}}-{{totalData}} of {{totalData}}</span>
                        <span
                          v-if="((perPage*page)<=totalData)"
                          style="color: #3199bb;font-size:12;font-weight:700; "
                        >{{perPage*(page-1)+1}}-{{perPage*page}} of {{totalData}}</span>
                      </div>
                      <div class="col-6 d-flex justify-content-center">
                        <b-pagination :total-rows="totalData" v-model="page" :per-page="perPage" />
                      </div>
                    </div>
                  </div>
                  <div v-else style="margin: auto;" class="mt-3">
                    <p>Không có sáng kiến nào được thấy!</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-sm-12 col-md-4 col-lg-4 mt-4">
              <div class="filter">
                <div class="filter-top col-12">
                  <span>Lọc theo</span>
                  <div class="btn btn-clear" @click="clearFilter(true)">Xóa</div>
                </div>
                <div class="filter-body col-12">
                  <div class="form-group">
                    <label>CTTV</label>
                    <v-select
                      label="name"
                      placeholder="TẤT CẢ"
                      :options="masterData.cttv"
                      v-model="searchForm.companyCode"
                      :reduce="p => p.lowerCode"
                    ></v-select>
                  </div>
                  <div class="form-group">
                    <div>
                      <label>LĨNH VỰC</label>
                      <v-select
                        label="name"
                        placeholder="TẤT CẢ"
                        :options="masterData.dataTypes"
                        :reduce="p => p.code"
                        v-model="searchForm.type"
                      ></v-select>
                    </div>
                  </div>

                  <div class="form-group">
                    <label>TÁC GIẢ</label>
                    <input
                      class="form-control mt-0"
                      placeholder="Nội dung kìm kiếm"
                      v-model="searchForm.author"
                      v-on:keyup.enter="getListIPs(true)"
                    />
                  </div>

                  <div class="form-group">
                    <label>NĂM ĐĂNG KÍ</label>
                    <date-picker
                      v-model="yearRegistration"
                      :disabled-date="disabledEndTime"
                      type="year"
                      placeholder="Chọn năm"
                      class="date-control date-height mr-2 mb-2"
                    ></date-picker>
                  </div>

                  <div class="form-group">
                    <label>DANH HIỆU IKHIẾN</label>
                    <v-select
                      label="name"
                      placeholder="TẤT CẢ"
                      :options="masterData.medals"
                      v-model="searchForm.medal"
                      :reduce="p => p.code"
                    ></v-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/common/Header";
import Footer from "@/components/common/Footer";
import ListGrid from "@/components/layout/ListGrid.vue";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import moment from "moment";
import newtopicLogo from "@/assets/images/newtopic.svg";
import aiKnowledgeLogo from "@/assets/images/aiknowledge.png";
import businessKnowLogo from "@/assets/images/trainingdocument.png";
import caseStudyLogo from "@/assets/images/casestudy.png";
import caseToolLogo from "@/assets/images/casetools.png";
import freeStyleLogo from "@/assets/images/freedefine.png";
import proposalLogo from "@/assets/images/proposal.png";
import serviceOfferingLogo from "@/assets/images/servicesoffering.png";
import softwareComponentLogo from "@/assets/images/softwarecomponent.png";
import standardSolutionLogo from "@/assets/images/standardsolutions.png";
import technicalKnowledgeLogo from "@/assets/images/knowhow.png";
import * as CONFIG from "../../config/index";
import helper from "../../common/helper";
import { BPagination } from "bootstrap-vue";
import axios from "axios";
import { ipType } from "../const/ipType";
import ideaCommon from "../../common/idea";
const initFilterData = {
  companyCode: "",
  type: "",
  author: "",
  year: "",
  prize: "",
  medal: ""
};

const medalsDefault = [
  {
    code: "1",
    name: "Sáng tạo của năm"
  },
  {
    code: "2",
    name: "Giải nhì năm"
  },
  {
    code: "gold",
    name: "Vàng"
  },
  {
    code: "silver",
    name: "Bạc"
  },
  {
    code: "bronze",
    name: "Đồng"
  },
  {
    code: "consolation",
    name: "Khuyến khích"
  }
];

const defaultData = function() {
  return {
    textSearch: "",
    yearRegistration: "",
    masterData: {
      cttv: [],
      dataTypes: [],
      medals: medalsDefault
    },
    column: 3,
    itemClass: "col-4",
    loading: false,
    totalData: 0,
    page: 1,
    perPage: 21,
    dataSearch: [],
    searchForm: { ...initFilterData },
    searchText: ""
  };
};

export default {
  name: "BrowseIP",
  components: {
    Header,
    Footer,
    ListSearch: ListGrid,
    BPagination,
    DatePicker
  },
  data() {
    return defaultData();
  },
  computed: {
    type() {
      return this.$route.params.type;
    },
    isPageSangKien() {
      return this.$route.params.type == "sangkien";
    },
    isPageiKhien() {
      return this.$route.params.type == "ikhien";
    }
  },
  created() {
    // this.masterData.dataTypes = ipType;
    this.getAllCompany();
    // this.getMedals();
    this.getIdearType();
    this.checkSearchData();
    this.getListIPs(true);
  },
  methods: {
    clearFilter: function(isSearch = false) {
      this.searchForm = Object.assign({}, initFilterData);
      this.yearRegistration = "";
      this.dataSearch = [];
      if (isSearch) {
        this.getListIPs(true);
      }
    },
    checkSearchData() {
      const textSeach = localStorage.getItem("home_search_engine_input");
      const comboBoxTemp = { ...initFilterData };
      if (textSeach) {
        this.searchText = textSeach;
        localStorage.removeItem("home_search_engine_input");
      }

      const typeSeach = localStorage.getItem("search-type");
      if (typeSeach) {
        comboBoxTemp.type = typeSeach;
        localStorage.removeItem("search-type");
      }
      const companySeach = localStorage.getItem("search-company");
      if (companySeach) {
        comboBoxTemp.companyCode = companySeach.toLowerCase();
        localStorage.removeItem("search-company");
      }
      this.searchForm = comboBoxTemp;
      this.getListIPs(true);
    },
    async getListIPs(isStartPage) {
      if (this.isPageiKhien) {
        return;
      }
      if (typeof this.searchForm.companyCode === "object") {
        this.searchForm.companyCode = this.searchForm.companyCode
          ? this.searchForm.companyCode.code
          : "";
      }

      if (isStartPage) {
        this.page = 1;
      }
      this.searchForm.title = this.searchText;
      if (this.yearRegistration) {
        this.searchForm.year = moment(this.yearRegistration).format("YYYY");
      } else {
        this.searchForm.year = "";
      }

      try {
        this.loading = true;
        const result = await ideaCommon.searchIdea(
          this.searchForm,
          this.page,
          this.perPage
        );

        this.dataSearch = result.items;
        this.totalData = result.totals;

        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
    },
    redirect: function(href) {
      window.location.href = href;
    },
    getColumnbyWidthScreen() {
      if (window.innerWidth < 768) {
        this.column = 1;
      } else if (window.innerWidth >= 768 && window.innerWidth < 1024) {
        this.column = 2;
      } else {
        this.column = 3;
      }
    },
    onPageLoad: function() {
      this.page = 1;
      this.clearFilter();
    },
    async getAllCompany() {
      try {
        let res = await axios.get(
          CONFIG.API_URL + "/company/search?pageNo=1&pageSize=1000"
        );
        this.masterData.cttv = res.data.data.items;
      } catch (e) {
        console.error(e);
      }
    },
    async getMedals() {
      try {
        let res = await axios.get(
          CONFIG.API_URL + "/master-data/get-by-type?type=idea_medal"
        );
        this.masterData.medals = res.data.data.items;
      } catch (e) {
        console.error(e);
      }
    },
    async getIdearType() {
      try {
        let res = await axios.get(
          CONFIG.API_URL + "/master-data/get-by-type?type=idea_type"
        );
        this.masterData.dataTypes = res.data.data.items;
      } catch (e) {
        console.error(e);
      }
    },
    disabledEndTime(date) {
      return date > new Date();
    }
  },
  mounted() {
    this.getColumnbyWidthScreen();
  },
  watch: {
    page: {
      immediate: false,
      handler(newVal, oldVal) {
        this.getListIPs();
      }
    },
    $route(to, from) {
      this.onPageLoad();
    },
    "searchForm.companyCode"() {
      this.getListIPs(true);
    },
    "searchForm.type"() {
      this.getListIPs(true);
    },
    "searchForm.medal"() {
      this.getListIPs(true);
    },
    yearRegistration() {
      this.getListIPs(true);
    }
  }
};
</script>

<style scoped>
.browse-top h2 {
  margin-top: 20px;
  margin-bottom: 10px;
  font-size: 30px;
  font-weight: 500;
  line-height: 1.1;
  color: #676a6c;
}
.browse-top p {
  color: #676a6c;
}

.filter {
  margin-left: 0px;
  box-shadow: 0px 2px 5px 2px rgba(0, 0, 0, 0.16);
  border-radius: 4px;
  background-color: #fff;
}

.filter-top {
  border-bottom: 1px solid #eee;
  padding: 15px 30px;
  display: flex;
  align-items: center;
}

.filter-top span {
  color: #677897;
  font-size: 14px;
  font-weight: bold;
}

.filter-top .btn-clear {
  color: #fff;
  background-color: #3199bb;
  border: 1px solid #3199bb;
  font-size: 12px;
  padding: 3px 10px;
  margin-left: auto;
}

.filter-body {
  padding: 15px 30px;
}

.filter-body label {
  font-weight: bold;
  font-size: 13px;
  color: #677897;
}

.form-control {
  margin-top: 15px;
}

.list-grid .b-pagination {
  margin-left: auto;
  margin-right: 7px;
}

.date-control {
  height: 38px;
  width: 100%;
}

.btn-search {
  background-color: #3199bb;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/BrowseIP.vue